import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptAudioService} from '@spout/web-global/data-access';

@Component({
  selector: 'spt-help-latency-vs-offset-content',
  templateUrl: './help-latency-vs-offset-content.component.html',
  styleUrls: ['./help-latency-vs-offset-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpLatencyVsOffsetContentComponent {
  constructor(private sptAudioService: SptAudioService) {}
  refresh(): void {
    this.sptAudioService.refreshAudioDeviceList().subscribe(() => {});
  }
}
